export default {
  install(Vue) {
    Number.prototype.numberFormat = function() {
      return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    Number.prototype.numberFormatToKorean = function() {
      const inputNumber  = this < 0 ? false : this;
      const splitUnit    = 10000;

      if (inputNumber < splitUnit) {
        return inputNumber.numberFormat()
      }
      else {
       return Math.floor(inputNumber / splitUnit).numberFormat() + '만';
      }
    }

    String.prototype.stripTag = function() {
      var text = this.replace(/<br>/ig, "\n")
      text = text.replace(/<br\/>/ig, "\n")
      text = text.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/ig, "")

      return text
    }

    String.prototype.getQueryString = function(key) {
      var _parammap = {}

      this.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function() {
        function decode(s) {
            return decodeURIComponent(s.split("+").join(" "))
        }

        _parammap[decode(arguments[1])] = decode(arguments[2])
      });

      return _parammap[key]
    }

    String.prototype.patternCheck = function(flag) {
      var pattern = ''

      switch (flag) {
        //영문만 유효성 검사
        case 'eng':
          pattern = /^[a-z|A-Z]+$/
          break
        //영문,숫자 유효성 검사
        case 'engnum':
          pattern = /^[(a-z|A-Z)0-9]+$/
          break
        //아이디 영문,숫자,underbar(_) 사용 유효성 검사
        case 'id':
          pattern = /^[(a-z|A-Z)0-9]+[_]*[(a-z|A-Z)0-9]+$/
          break
        //정수 유효성 검사
        case 'num':
          pattern = /^[0-9]+$/
          break
        //영문,숫자 혼합사용 유효성 검사
        case 'wordnum':
          pattern = /^([0-9]+[a-z|A-Z]+)|([a-z|A-Z]+[0-9]+)$/
          break
        //이메일 유효성 검사
        case 'email':
          pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
          break
        //비밀번호 유효성 검사: 영문,숫자,특수문자 조합의 8 ~ 20자.
        case 'password':
          pattern = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/
          break
        //닉네임 유효성 검사: 2~15자 이내의 한글,영문,숫자만.
        case 'name':
          pattern = /^([ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|]){2,15}$/
          break
        // 휴대폰 번호
        case 'phone':
          pattern = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/
          break
        //생년월일 8자리
        case 'yyyymmdd':
          pattern = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/
          break
        //반려동물이름 유효성 검사: 1~15자 이내의 한글,영문,숫자만.
        case 'petName':
          pattern = /^([ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|]){1,15}$/
          break
      }

      return pattern.test(this.toString())
    }

    String.prototype.removeSpace = function() {
      if (this.trim().length > 0 || this.trim()) {
        return this.trim().replace(/ /g,'')
      } else {
        return ""
      }
    }

    String.prototype.nl2br = function() {
      if (this.trim().length > 0 || this.trim()) {
        // return this.trim().replace(/\n/g, "<br>")
        return this.trim().replace(/(?:\r\n|\r|\n)/g,'</br>')
      } else {
        return ""
      }
    }

    String.prototype.isEmpty = function(str) {
      if (this.length === 0 || this === null || this === undefined) {
        if (str != '' && str !== undefined) {
          return str
        } else {
          return ''
        }
      } else {
        return this
      }
    }

    String.prototype.thumbnail = function() {
      var path = this.split('/')
      return path[0] + '/thumb/' + path[1]
    }

    String.prototype.getAge = function() {
      let sp = this.split('-')
      let date = new Date(sp[0], sp[1], sp[2], 0, 0, 0)
      let now = new Date()
      let age = now.getFullYear() - date.getFullYear()

      if (date.getMonth() < now.getMonth()) {
        age--
      } else if (date.getDate() < now.getDate()) {
        age--
      }

      return age
    }

    //=========================================================================
    //  함수 명 : phoneNumber
    //  함수 설명 : 핸드폰 번호 대쉬 삽입 처리
    //=========================================================================
    String.prototype.phoneNumber = function() {
      let str = ''
      const len = this.length

      if (len == 9) {
        str = this.substr(0, 2) + '-' + this.substr(2, 3) + '-' + this.substr(5, 4)
      } else if (len == 10) {
        str = this.substr(0, 3) + '-' + this.substr(3, 3) + '-' + this.substr(6, 4)
      } else if (len == 11) {
        str = this.substr(0, 3) + '-' + this.substr(3, 4) + '-' + this.substr(7, 4)
      }

      return str
    }

    //=========================================================================
    //  함수 명 : mask
    //  함수 설명 : 각종 마스킹 처리
    //=========================================================================
    String.prototype.mask = function(type='')  {
      let str = '', email = '', addr = ''

      // 설정 값을 받아 그에 맞게 마스킹 처리 한다.
      if (type != '') {
        if (this != '') {
          if (type == 'id') {
              str = this.substr(0, 5) + '*'.repeat(strlen(this) - 5)
          } else if (type == 'email') {
            email = this.split('@')

            if (email[0].length > 5) {
              str = email[0].substr(0, 5) + '*'.repeat(strlen(email[0]) - 5) + '@' + email[1]
            } else if (email[0].length < 3) {
              str = email[0] + '@' + email[1]
            } else {
              str = email[0].substr(0, 3) + '*'.repeat(strlen(email[0]) - 3) + '@' + email[1]
            }
          } else if (type == 'phone') {
              str = this.substr(0, 4) + '-****-' + this.substr(-4)
          } else if (type == 'addr') {
            addr = this.split(' ')

            if (typeof addr == 'array') {
              for (let i = 0; i < addr.length; i++) {
                if (i > 1) {
                  str += '*'.repeat(addr[i].length) + ' '
                } else {
                  str += addr[i] + ' '
                }
              }
            }
          }
        }
      } else {
        // 사용자 명 마스킹
        str = this.substr(0, 1) + '*' + this.substr(2)
      }

      return str
    }

    Array.prototype.inArray = function(find) {
      return this.indexOf(find) > -1 ? true : false
    }

    Array.prototype.indexRemove = function(find) {
      return this.splice(this.indexOf(find), 1)
    }



    //알림 메시지
    Vue.prototype.$alert = function(opt) {
      var msg = '', title = '엄마 좀 쉬자', btnName = '확인', url = '', callback = null

      //msg, url, title, btnName, callback
      if (typeof opt == 'object') {
        msg = opt.msg

        if (opt.title) {
          title = opt.title
        }

        if (opt.btnName) {
          btnName = opt.btnName
        }

        if (typeof opt.callback == 'function') {
          callback = opt.callback
        }
      } else {
        msg = opt
      }

      if (this.$store.getters.getDeviceReady) {
        navigator.notification.alert(msg, callback, title, btnName)
      } else {
        alert(msg);

        if (typeof callback == "function") {
          callback.call()
        }
      }

      if (url) {
        this.$router.push(url)
      }

      return false
    }

    Vue.prototype.$confirm = function(msg, title, buttons, callback) {
      if (!callback) callback = null
      if (!title) title = "엄마 좀 쉬자"
      if (!buttons) buttons = ["확인", "취소"]

      if (this.$store.getters.getDeviceReady) {
        navigator.notification.confirm(msg, callback, title, buttons)
      } else {
        if (confirm(msg)) {
          if (typeof callback == "function") {
            callback.call(1)
          }
        }
      }

      return false;
    }

    Vue.prototype.$showAside = function(flag) {
      this.$store.commit('setAsideState', flag)
    }

    Vue.prototype.$diaryPhotoPath = function(filePath, thumbnail = false) {
      let file =  ''

      // 파일의 경로라 구 경로 일 경우
      if (filePath.indexOf('/photo') > -1) {
        file = filePath.replace('/file/photo', '/upload/profile')
      } else {
        file = filePath
      }

      if (thumbnail) {
        let tmp = file.split('/')

        return this.$store.state.diaryUrl + '/' + tmp[0] + '/thumb/' + tmp[1]
      } else {
        return this.$store.state.diaryUrl + '/' + file
      }
    }

    Vue.prototype.$parseJwt = (token) => {
      if (!token) return false
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }

    Vue.prototype.$getJwtInfo = (jwt) => {
      if (jwt) {
        let idx = jwt.indexOf('.ggolab')
        if (idx > -1) {
          idx = idx + 1
        }
        else {
          return false
        }

        let token = jwt.substring(0, idx) + jwt.substring(jwt.indexOf('.ggolab')+7)
        return Vue.prototype.$parseJwt(token)
      }
    }

    Vue.prototype.$isIE = () => {
      const agent = navigator.userAgent.toLowerCase();
      if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (agent.indexOf("msie") != -1) ) {
        return true
      }
      else {
        return false
      }
    }

    Vue.prototype.$MBtoB = (mb) => {
      if (!mb) return 10485760 // 10MB
      return mb * 1024 * 1024
    }

    Vue.prototype.$getExts = (name, toUpper) => {
      let ext = 'etc';
      if (name && name.lastIndexOf('.') > -1) {
        ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
        if (ext && toUpper) {
          return ext.toUpperCase();
        }
      }
      return ext;
    }

    Vue.prototype.$isImages = (ext) => {
      let imgMap = {
        'png': true,
        'jpg': true,
        'jpeg': true,
        'gif': true,
        // 'webp': true,
      };
      if (!ext) {
        return false;
      }
      return imgMap[ext.toLowerCase()];
    }

    Vue.prototype.$isMobileCheck = () => {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }

    Vue.prototype.$mobileAndTabletCheck = () => {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }

    Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)

    Vue.prototype.$arrayOfObjectMax = (x) => Math.max.apply(Math, this.map(o => o[x]));
  }
}
